import { HTMLTooltipComponent } from "../controlWC/TooltipComponent"
import { UIUtilElement } from "../util/Element"
import ic_info from "/image/iconos/ic_infomark.svg?raw"

export function _InfoIcon(parentElement: HTMLElement, tooltipText: string): HTMLTooltipComponent {
    const icInfo: HTMLElement = UIUtilElement._CreateElementFromHTML(ic_info);
    icInfo.classList.add("ic_info");
    icInfo.style.width = "var(--padding3)";
    icInfo.style.marginLeft = "var(--padding1)";
    parentElement.append(icInfo);
    const tooltip = new HTMLTooltipComponent();
    parentElement.append(tooltip);
    tooltip._SetObservedElementsAdvanced({ Target: icInfo as HTMLElement, Text: tooltipText })
    return tooltip;
}